jPar.loginAndRegistration = jPar.loginAndRegistration || {};
$j.extend(true, jPar.loginAndRegistration, {
	genderSelectPage_deprecated: {
		init: function init() {
			jPar.wdk.forms.init();
			this.genderSelectBox.init();

			document.querySelector('#formGenderSelection').addEventListener('submit', (event) => {
				this.validate.validateForm();
				if (jPar.wdk.forms.hasVisibleErrors(event.target)) {
					event.preventDefault();
				}
			});
		},

		genderSelectBox: {
			hasEsSex: true,

			init: function () {
				this.hasEsSex = document.querySelector('#essexRow') !== null;

				document.querySelectorAll('#formGenderSelection #mysexRow input[type=radio]').forEach((mySexRadio) => {
					mySexRadio.addEventListener('click', (event) => {
						this.mySexClick(event);
					});
				});

				document.querySelectorAll('#formGenderSelection #essexRow input[type=checkbox]').forEach((esSexCheckbox) => {
					esSexCheckbox.addEventListener('click', (event) => {
						this.esSexClick(event);
					});
				});
			},

			mySexClick: function (event) {
				this.preselectEsSex(event.target);
				this.handleHideError();
			},

			esSexClick: function (event) {
				event.preventDefault();
				event.stopPropagation();

				window.setTimeout(function () {
					// Der Browser meldet hier ansonsten falschen checked status, warum ist das so???
					if (event.target.checked === false) {
						event.target.checked = true;
					} else {
						const othercheckboxId = event.target.id === 'essexM' ? 'essexW' : 'essexM';
						const deselectAllowed = document.querySelector('#formGenderSelection #essexRow #' + othercheckboxId).checked === true;
						if (deselectAllowed) {
							event.target.checked = false;
						}
					}
				}, 0);

				this.preselectMySex(event.target);
				this.syncEsSexForSubmit();
				this.handleHideError();
			},

			preselectMySex: function (changedElement) {
				if (jPar.wdk.brands.forBrands(['ps', 'ep'])) {
					const hasNotCheckedMySex = document.querySelectorAll('#formGenderSelection #mysexRow [type=radio]:checked').length === 0;
					if (hasNotCheckedMySex) {
						// 0 = male; 1 = female; 3 = all;
						const esSexValue = changedElement.value;

						if (esSexValue === '0') {
							document.querySelector('#formGenderSelection #mysexW').click();
						} else {
							document.querySelector('#formGenderSelection #mysexM').click();
						}
					}
				}
			},

			preselectEsSex: function (changedElement) {
				if (jPar.wdk.brands.forBrands(['ps', 'ep']) && this.hasEsSex) {
					const hasNotCheckedEsSex = document.querySelectorAll('#formGenderSelection #essexRow [type=checkbox]:checked').length === 0;
					if (hasNotCheckedEsSex) {
						// 0 = male; 1 = female; 3 = all;
						const mySexValue = changedElement.value;

						if (mySexValue === '0') {
							document.querySelector('#formGenderSelection #essexW').click();
						} else {
							document.querySelector('#formGenderSelection #essexM').click();
						}
					}
				}
			},

			syncEsSexForSubmit: function () {
				const femaleChecked = document.querySelector('#formGenderSelection #essexRow #essexW:checked') !== null;
				const maleChecked = document.querySelector('#formGenderSelection #essexRow #essexM:checked') !== null;

				if (femaleChecked && maleChecked) {
					document.querySelector('#formGenderSelection #hiddenEssex').value = '3';
				} else if (femaleChecked) {
					document.querySelector('#formGenderSelection #hiddenEssex').value = '1';
				} else if (maleChecked) {
					document.querySelector('#formGenderSelection #hiddenEssex').value = '0';
				}
			},

			handleHideError: function () {
				const mysexChecked = document.querySelectorAll('#formGenderSelection input[name="mysex"]:checked').length === 1;
				let essexChecked;

				if (this.hasEsSex) {
					essexChecked = document.querySelector('#formGenderSelection input[name="essex"]').value !== '';
				} else {
					essexChecked = true;
				}

				if (mysexChecked && essexChecked) {
					jPar.wdk.forms.hideError(document.querySelector('#formGenderSelection  #regsexError'));
				}
			},
		},

		validate: {
			validateForm: function validateForm() {
				this.validateSex();
			},

			validateSex: function validateSex() {
				jPar.wdk.forms.showError(document.querySelector('#regsexError'));

				const hasNoSelectedMySex = document.querySelectorAll('#formGenderSelection input[name="mysex"]:checked').length === 0;
				let hasNoSelectedEsSex;

				if (jPar.loginAndRegistration.genderSelectPage_deprecated.genderSelectBox.hasEsSex) {
					hasNoSelectedEsSex = document.querySelector('#formGenderSelection input[name="essex"]').value === '';
				} else {
					hasNoSelectedEsSex = false;
				}

				if (hasNoSelectedMySex || hasNoSelectedEsSex) {
					jPar.wdk.forms.showError(document.querySelector('#regsexError'));
				} else {
					jPar.wdk.forms.hideError(document.querySelector('#regsexError'));
				}
			},
		},
	},
});
